import { ACTIVITY_LOGS, DASHBOARD } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getOverviewData: build.query({
      query: (params = {}) => ({
        url: DASHBOARD.TOTAL,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Dashboard', id: 'OVERVIEW' }],
    }),
    getAdminDashboardData: build.query({
      query: (params = {}) => ({
        url: DASHBOARD.ADMIN,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Dashboard', id: 'ADMIN' }],
    }),
    getCloserDashboardData: build.query({
      query: (params = {}) => ({
        url: DASHBOARD.CLOSER,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Dashboard', id: 'CLOSER' }],
    }),
    getCallsCounterSummary: build.query({
      query: (params = {}) => ({
        url: DASHBOARD.CALLS_COUNTER_SUMMARY,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Dashboard', id: 'CALLS_COUNTER' }],
    }),
    getLeadsComments: build.query({
      query: (params = {}) => ({
        url: DASHBOARD.LEADS_COMMENTS,
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'Dashboard', id: 'LEADS_COMMENTS' }],
    }),
    getRecentActivities: build.query({
      query: (arg = {}) => {
        const { page = 1, pageSize, per_page, search = '', ...rest } = arg;
        return {
          url: ACTIVITY_LOGS.LIST,
          method: 'GET',
          params: {
            page,
            per_page: per_page ?? pageSize ?? 5,
            search,
            ...rest,
          },
        };
      },
      providesTags: (result) => listTags('ActivityLog', result),
    }),
    getActivityLogById: build.query({
      query: (id) => ({ url: ACTIVITY_LOGS.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'ActivityLog', id }],
    }),
  }),
});

export const {
  useGetOverviewDataQuery,
  useLazyGetOverviewDataQuery,
  useGetAdminDashboardDataQuery,
  useLazyGetAdminDashboardDataQuery,
  useGetCloserDashboardDataQuery,
  useLazyGetCloserDashboardDataQuery,
  useGetCallsCounterSummaryQuery,
  useLazyGetCallsCounterSummaryQuery,
  useGetLeadsCommentsQuery,
  useLazyGetLeadsCommentsQuery,
  useGetRecentActivitiesQuery,
  useLazyGetRecentActivitiesQuery,
  useGetActivityLogByIdQuery,
  useLazyGetActivityLogByIdQuery,
} = dashboardApi;
